module.exports = __webpack_public_path__ + "img/pdf.272ca3bd.png";